import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {clearStorage, getStorage, getToken, removeToken} from '@/utils/auth' // get token from cookie
import User from '@/store/modules/user'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/simulateLogin', '/auth-redirect', '/userProtocol', '/yinsi'] // no redirect whitelist

router.beforeEach( (to, from, next) => {
  console.log('beforeEach', 'to.path=', to, 'from.path', from)
  // start progress bar
  NProgress.start()
  const dom = document.getElementById('mainContainer')
  if (dom) {
    dom.scrollTop = 0
  }
  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    console.log(hasToken, 'hasToken', to.path, to.query)
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({path: '/'})
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {

      // 判断是否有所属圈子
      const now_circle_code = getStorage('now_circle_code')
      if(!now_circle_code && to.path === '/publish/discuss'){
         // 如果没有所属圈子，则跳转到注册页面
         next({path: '/register'})
        return
      }

      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      console.log('hasRoles', hasRoles, router)
      console.log('store.getters.roles', store.getters.roles)
      if (hasRoles) {
        console.log('routes', router.options.routes)
        console.log('hasRoles-next')
        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          // const {roles} = await store.dispatch('user/getInfo')
          User.mutations.SET_ROLES(store.state.user, 'admin', -2)
          let croles = localStorage.getItem('rights')
          // console.log('juese', roles, croles)
          try {
            if (typeof croles === 'string') {
              croles = JSON.parse(croles)
            }
          } catch (e) {
            croles = []
            clearStorage()
            localStorage.clear()
            removeToken()
            next('/')
            return
          }

          // generate accessible routes map based on roles
          // const accessRoutes = await store.dispatch('permission/generateRoutes', croles)
          store.dispatch('permission/generateRoutes', croles).then(e=>{
            const accessRoutes = e
            console.log('accessRoutes', accessRoutes)

            // dynamically add accessible routes
            router.addRoutes(accessRoutes)

            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
            next({ ...to, replace: true })
          })

        } catch (error) {
          // remove token and go to login page to re-login
         store.dispatch('user/resetToken').then(() => {
           // console.log(typeof error, error, "====error===")
           Message.error({ message: error || 'Has Error' })
           next(`/login?redirect=${to.path}`)
           NProgress.done()
         })

        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      console.log('go-whiteList', to.path)
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
